import { Pipe, PipeTransform } from '@angular/core';
import {Observable, of} from 'rxjs';
import {BlocksHelper} from '../../helper/blocks.helper';

@Pipe({
    name: 'tClassBlockName',
    standalone: false
})
export class TClassBlockNamePipe implements PipeTransform {

  constructor(private blocksHelper: BlocksHelper) {
  }

  transform(value: string): string {
    const result = this.blocksHelper.tclasses.filter((b) => b.id === value)[0].description;
    return result;
  }
}
